import formInput from 'guardian-liveness-detection-lib/src/libs/formInput'

export async function takeVideoHandler(): Promise<File> {
  const file = await formInput()
  return file
}
